module.exports = __webpack_public_path__ + "static/media/PT2A.42628e78.png";